//TODO: replace svg w/one thatdesign will make which displays property at 18px size and maintains whitespace.
import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconUpload(props: SvgIconProps) {
  return (
    <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2 11V13C2 14.1046 2.89543 15 4 15H14C15.1046 15 16 14.1046 16 13V11"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M5.00012 6L9.00012 2L13.0001 6" stroke="currentColor" strokeWidth="2" />
      <path d="M9.00012 2L9.00012 12" stroke="currentColor" strokeWidth="2" />
    </SVGIcon>
  );
}
